import React, { useEffect, useState } from 'react'
import { inject, observer } from 'mobx-react'
import './AssetDetails.scss'
import _ from 'lodash'
import {
  faEye, faArrowLeft, faLock, faLockOpen
} from '@fortawesome/free-solid-svg-icons'
import ReactTooltip from 'react-tooltip'
import { constants } from '../../../store/constants'
import Table from '../../../components/Table/Table'
import Button from '../../../components/Button/Button'
import Modal from '../../../components/Modal/Modal'

const TemplateDetails = ({
  notificationStore,
  templatesStore,
  paid,
  backButton,
}) => {
  const [state, setState] = useState({
    // eslint-disable-next-line react/destructuring-assignment
    paid,
    templateData: {},
    showTemplateFormModal: false,
    originalTemplateValue: {},
    latestTemplateValue: {},
    showTemplateOverviewModal: false,
    templateDetail: {},
  })

  useEffect(() => {
    const init = async () => {
      const fetchData = async () => {
        await templatesStore.getTemplates({ paid: state.paid })

        setState({
          ...state,
          templateData: templatesStore.templatePage.data,
        })
      }

      fetchData()
    }
    init()
    ReactTooltip.rebuild()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const changeStatus = async (item)=>{
    const templateData = {
      id: item._id,
      paid: item.paid,
      isLocked: !item.isLocked,
    }

    await templatesStore.lockUnlockTemplate(templateData)
    await templatesStore.getTemplates({ paid: templateData.paid })

    setState({
      ...state,
      originalTemplateValue: {},
      latestTemplateValue: {},
      templateData: templatesStore.templatePage.data,
    })
  }
  
  const openTemplateOverviewModal = async (currentTemplate) => {
    setState({
      ...state,
      showTemplateOverviewModal: true,
      templateDetail: currentTemplate,
    })
  }

  const templatesTableHeaders = [{
    label: '_id',
    key: '_id',
    styles: {
      width: '200px',
      justifyContent: 'center',
    },
  }, {
    label: 'Project App ID',
    key: 'paid',
    styles: {
      flex: 1,
    },
  }, {
    label: 'Name',
    key: 'name',
    styles: {
      flex: 1,
    },
  }, {
    label: 'Lock Status',
    key: 'isLocked',
    styles: {
      flex: 1,
    },
    render: (item) => (
      <div className="config-buttons">
        <Button
          // label="email"
          dataTip={item.isLocked ? 'Unlock this Template' : 'Lock this Template'}
          icon={item.isLocked ? faLock : faLockOpen}
          // disabled={item.isLocked}
          variant={item.isLocked ? 'error' : 'primary'}
          // onClick={() => { openTemplateFormModal(item) }}
          onClick={() => { changeStatus(item) }}
          customStyle={{ marginRight: 50 }}
        />
        <ReactTooltip />
      </div>
    ),
  }]

  const goBack = () => {
    backButton()
  }

  const handlePageChange = (query) => {
    templatesStore.getTemplates({ ...query, paid: state.paid })
  }

  return (
    <>
      <div className="page-content">
        <div style={{ display: 'flex', alignItems: 'baseline' }}>
          <Button
            dataTip="Back To Dashboard"
            icon={faArrowLeft}
            variant="primary"
            onClick={goBack}
            customStyle={{ marginRight: 50 }}
          />
          <div>
            TEMPLATES FOR PAID: &nbsp;
            {state.paid}
          </div>
        </div>
        <Table
          headers={templatesTableHeaders}
          page={{
            ...templatesStore.templatePage,
            data: templatesStore.templatePage.data,
          }}
          onPageChange={handlePageChange}
        >
          <Button
            dataTip="Overview"
            variant="primary"
            icon={faEye}
            onClick={openTemplateOverviewModal}
          />
          <ReactTooltip />
        </Table>
      </div>

      <Modal
        show={state.showTemplateOverviewModal}
        onDismiss={() => { setState({ ...state, showTemplateOverviewModal: false }) }}
        noSubmit
        header="Template Detail"
        width="30%"
      >
        <div style={{ wordWrap: 'break-word' }}>        
          <pre>{JSON.stringify(state.templateDetail, null, 4)}</pre>
        </div>
      </Modal>
    </>
  )
}

export default inject(
  constants.notificationStore,
  constants.templatesStore,
)(observer(TemplateDetails))
